/* eslint-disable no-unused-vars */
import React, { useEffect, useState } from "react";
import { connect } from "react-redux";
import Swal from "sweetalert2";
import globalColors from "../../../../../../../_metronic/_assets/sass/custom/globalColors.scss";
import { AppAPIService } from "../../../../../../services/AppAPIService";
import Loading from "../../../../../home/components/Loading";
import store from "../../../../../../store/store";
import { Grid, Container } from "@material-ui/core";
import { LabelWithBackLine } from "../../../../../../components/LabelWithBackLine";
import { UserDocumentsTable } from "./UserDocumentsTable";
import { makeStyles } from "@material-ui/core/styles/";

export const UserDocumentsDataTable = (props) => {
  const useStyles = makeStyles(() => {
    return {
      root: {
        maxHeight: "fit-content",
        display: "flex",
        flexDirection: "column",
        width: "100%",
        height: "100%",
        minHeight: "75vh",
        borderRadius: "4px",
        boxShadow: `0 2px 4px rgba(0, 0, 0, 0.1)`,
      },
      paper: {
        width: "100%",
        flex: "1",
      },
      table: {
        minWidth: 400,
        overflowX: "scroll",
        background: `${globalColors.secondaryColor3}40`,
      },
      tableWrapper: {
        overflow: "hidden !important",
        display: "flex",
        justifyContent: "space-between",
        flexDirection: "column",
        height: "100%",
        overflowX: "auto",
        borderRadius: "4px",
        boxShadow: props.removeShadow
          ? "none"
          : "0px 1px 1px rgba(0, 0, 0, 0.14), 0px 2px 1px rgba(0, 0, 0, 0.12), 0px 1px 3px rgba(0, 0, 0, 0.2)",
        border: "none",
      },
      tableContainer: {
        padding: "0 16px 0px 16px",
        marginTop: "5px",
      },
      search: {
        padding: 16,
      },
      input: {
        border: `.5px solid ${globalColors.backgroundColor2}`,
        paddingRight: "10px",
        borderRadius: "4px",
        height: "48px",
        marginRight: "10px",
      },
      rows: {
        padding: "0 !important",
        margin: "0 !important",
      },
      addBtn: {
        padding: "16px 0",
        marginLeft: "16px",
      },
    };
  });
  const classes = useStyles();

  let api = AppAPIService.getInstance();
  const { auth } = store.getState();

  const userId = props?.userId;

  const [reload, setReload] = useState(false);
  const [loading, setLoading] = useState(false);

  const handleConfirmDelete = async (id) => {
    try {
      setLoading(true);
      await api.makeHttpRequest({
        method: "DELETE",
        url: `/lawsuit/${id}`,
      });

      setReload(!reload);
      setLoading(false);
      Swal.fire({
        title: "Sucesso!",
        text: "Processo deletado com sucesso.",
        icon: "success",
        cancelButtonText: "Sair",
      });
    } catch (e) {
      Swal.fire("Erro!", "Erro ao deletar documento.", "error");
    }

    setLoading(false);
  };

  const handleConfirmChangeStatus = async (obj) => {
    try {
      await api.makeHttpRequest({
        method: "PATCH",
        url: `/lawsuit/toggle/${obj.id}`,
        data: {
          active: !obj.active,
        },
      });

      setReload(!reload);

      const lawsuitStatus = !obj.active ? "ativado" : "desativado";

      Swal.fire({
        title: "Sucesso!",
        text: `Processo ${lawsuitStatus} com sucesso!`,
        icon: "success",
        cancelButtonText: "Sair",
      });
    } catch (e) {
      Swal.fire("Erro!", "Erro ao alterar status.", "error");
    }
  };

  return (
    <>
      <Loading isLoading={loading} />
      <div
        style={{
          minHeight: "200px",
          maxHeight: "fit-content",
          borderRadius: "4px",
          boxShadow: "0px 1px 1px 1px rgba(0,0,0,0.2)",
          display: "flex",
          padding: "20px 20px 20px 20px",
        }}
        className={`${classes.root}`}
        maxWidth="xxl"
      >
        <Grid container spacing={3}>
          <Grid
            item
            xs={12}
            style={{
              width: "100%",
            }}
          >
            <LabelWithBackLine>Documentos do Cliente</LabelWithBackLine>
            <Container
              maxWidth="xl"
              style={{
                padding: 0,
                marginTop: "20px",
              }}
            >
              <UserDocumentsTable
                refetchLogs={props.refetchLogs}
                reload={reload}
                setReload={setReload}
                userReload={props.userReload}
                setUserReload={props.setUserReload}
                handleGetHistory={props.handleGetHistory}
                userId={userId}
              />
            </Container>
          </Grid>
        </Grid>
      </div>
    </>
  );
};

const mapStateToProps = ({ auth }) => ({
  user: auth.user,
});

export default connect(mapStateToProps)(UserDocumentsDataTable);
